module.exports = __webpack_public_path__ + "img/shoucangxiangqin.7c037cfa.svg";